import { Image, Pdf, Text } from '@berlitz/icons'

export const getIcon = (type: string) => {
  switch (type) {
    case 'application/pdf':
      return {
        Icon: Pdf,
      }
    case 'image/jpeg':
    case 'image/png':
      return {
        Icon: Image,
      }
    default:
      return {
        Icon: Text,
      }
  }
}
